/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import styles from '../../../styles/partials/filter-buttons.module.scss';

const propTypes = {
    filter: PropTypes.shape({
        id: PropTypes.string,
        type: PropTypes.string,
        options: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string,
                value: PropTypes.string,
            }),
        ),
    }).isRequired,
    value: PropTypes.shape({}).isRequired,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const FilterButtons = ({ filter: { id, options = null } = {}, value, onChange, className }) => {
    const onButtonClick = useCallback(
        (filterValue) => {
            const currentFilterValue = value !== null ? value[id] || [] : [];
            const newValue = {
                ...value,
                [id]:
                    currentFilterValue.indexOf(filterValue) !== -1
                        ? currentFilterValue.filter((it) => it !== filterValue)
                        : [...currentFilterValue, filterValue],
            };
            onChange(newValue);
        },
        [id, value, onChange],
    );

    const optionsSortedByType = (options || []).reduce((acc, opt) => {
        const { type } = opt;
        const optionsArray = acc[type] || [];
        return { ...acc, [type]: [...optionsArray, opt] };
    }, {});

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            {optionsSortedByType !== null &&
                Object.keys(optionsSortedByType).map((type) => (
                    <div key={type}>
                        {optionsSortedByType[type].length > 1
                            ? optionsSortedByType[type].map((option, index) => {
                                  const selected =
                                      value !== null &&
                                      (value[id] || []).indexOf(option.value) !== -1;
                                  const {
                                      label = null,
                                      color = null,
                                      backgroundColor = null,
                                  } = option || {};
                                  return (
                                      <button
                                          key={option.value}
                                          className={classNames(styles.button, styles[type], {
                                              [styles.isSelected]: selected,
                                          })}
                                          onClick={() => onButtonClick(option.value)}
                                          type="button"
                                          style={{
                                              color: !selected ? color : null,
                                              backgroundColor: !selected ? backgroundColor : null,
                                              // animationDelay: `${(index + 1) * 0.08 + 0.8}s`,
                                              textTransform:
                                                  label.toLowerCase() === 'urbania'
                                                      ? 'uppercase'
                                                      : null,
                                          }}
                                      >
                                          {label}
                                      </button>
                                  );
                              })
                            : null}
                    </div>
                ))}
        </div>
    );
};

FilterButtons.propTypes = propTypes;
FilterButtons.defaultProps = defaultProps;

export default FilterButtons;
